import { recordControllerTelemetry } from 'helpers/inputTelemetry';

export function initializeControllerInput(
  scene,
  moveInDirection,
  APressed,
  EnterPressed,
  SpacePressed,
  NumPressed,
  EPressed,
  BPressed,
  XPressed,
  LBPressed,
  RBPressed,
  startPressed,
  EscapePressed
) {
  const inputBlockedByModal = () => {
    const modalScene = window.__clInputModalScene;
    return modalScene && scene.scene?.key !== modalScene;
  };

  const gamepadButtonDown = (pad, button, value) => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    if (button) {
      recordControllerTelemetry(scene, button, {
        action: 'controller_button_down'
      });
      // console.log('controller button pressed:', button.index);
      switch (button.index) {
        case 0:
          APressed && APressed();
          break;
        case 1:
          BPressed && BPressed();
          break;
        case 2:
          XPressed && XPressed();
          break;
        case 3:
          EPressed && EPressed();
          break;
        case 4:
          LBPressed && LBPressed();
          break;
        case 5:
          RBPressed && RBPressed();
          break;
        case 9:
          startPressed && startPressed();
          break;
        case 12:
          onDirectionPress([0, -1]);
          break;
        case 13:
          onDirectionPress([0, 1]);
          break;
        case 14:
          onDirectionPress([-1, 0]);
          break;
        case 15:
          onDirectionPress([1, 0]);
          break;
        default:
          break;
      }
    }
  };
  const gamepadButtonUp = (pad, button, value) => {
    if (button) {
      switch (button.index) {
        case 12:
          releaseUp();
          break;
        case 13:
          releaseDown();
          break;
        case 14:
          releaseLeft();
          break;
        case 15:
          releaseRight();
          break;
        default:
          break;
      }
    }
  };
  const pressLeft = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.leftPressed = true;
    onDirectionPress([-1, 0]);
  };
  const pressRight = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.rightPressed = true;
    onDirectionPress([1, 0]);
  };
  const pressUp = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.upPressed = true;
    onDirectionPress([0, -1]);
  };
  const pressDown = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.downPressed = true;
    onDirectionPress([0, 1]);
  };

  const releaseLeft = () => {
    scene.game.leftPressed = false;
    scene.game.directControlContinuousMovement = false;
  };
  const releaseRight = () => {
    scene.game.rightPressed = false;
    scene.game.directControlContinuousMovement = false;
  };
  const releaseUp = () => {
    scene.game.upPressed = false;
    scene.game.directControlContinuousMovement = false;
  };
  const releaseDown = () => {
    scene.game.downPressed = false;
    scene.game.directControlContinuousMovement = false;
  };

  const pressEnter = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    EnterPressed && EnterPressed();
  };

  const pressEscape = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    EscapePressed && EscapePressed();
  };

  const pressSpace = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    SpacePressed && SpacePressed();
  };

  const pressE = () => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    EPressed && EPressed();
  };

  const pressNum = key => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    NumPressed && NumPressed(key);
  };

  const onDirectionPress = direction => {
    if (inputBlockedByModal()) {
      return;
    }
    scene.game.controllerInput = true;
    const dialogue = scene.scene.get('DialogueScene');
    if (dialogue.scene.settings.active) {
      return dialogue.moveInDirection(direction);
    }
    if (scene.inputTimer && scene.firstDirection) {
      clearTimeout(scene.inputTimer);
      const sameDirection =
        scene.firstDirection[0] === direction[0] &&
        scene.firstDirection[1] === direction[1];
      let newDirection = direction;
      if (!sameDirection) {
        newDirection = [
          scene.firstDirection[0] + direction[0],
          scene.firstDirection[1] + direction[1]
        ];
      }
      scene.inputTimer = null;
      scene.firstDirection = null;
      moveInDirection && moveInDirection(newDirection);
    } else {
      scene.firstDirection = direction;
      scene.inputTimer = setTimeout(() => {
        moveInDirection && moveInDirection(direction);
        scene.inputTimer = null;
        scene.firstDirection = null;
      }, 100);
    }
  };

  const removeControllerInputs = () => {
    if (scene.inputTimer) {
      clearTimeout(scene.inputTimer);
      scene.inputTimer = null;
      scene.firstDirection = null;
    }

    scene.input.gamepad && scene.input.gamepad.off('down', gamepadButtonDown);
    scene.input.gamepad && scene.input.gamepad.off('up', gamepadButtonUp);
    // left
    scene.leftA.off('down', pressLeft);
    scene.leftArrow.off('down', pressLeft);
    // right
    scene.rightD.off('down', pressRight);
    scene.rightArrow.off('down', pressRight);
    // up
    scene.upW.off('down', pressUp);
    scene.upArrow.off('down', pressUp);
    // down
    scene.downS.off('down', pressDown);
    scene.downArrow.off('down', pressDown);

    scene.leftA.off('up', releaseLeft);
    scene.leftArrow.off('up', releaseLeft);
    scene.rightD.off('up', releaseRight);
    scene.rightArrow.off('up', releaseRight);
    scene.upW.off('up', releaseUp);
    scene.upArrow.off('up', releaseUp);
    scene.downS.off('up', releaseDown);
    scene.downArrow.off('up', releaseDown);

    scene.spaceBar.off('down', pressSpace);
    scene.enterKey.off('down', pressEnter);
    scene.escKey.off('down', pressEscape);
    scene.keyboardE.off('down', pressE);
    Object.values(scene.keyboardNum).forEach(k => k.off('down', pressNum));

    scene.input.keyboard.removeCapture(
      'W,S,A,D,E,UP,DOWN,LEFT,RIGHT,SPACE,ENTER,ESC,ONE,TWO,THREE,FOUR,FIVE,SIX,SEVEN,EIGHT,NINE'
    );
  };

  const addControllerInputs = () => {
    scene.leftA.on('down', pressLeft);
    scene.leftArrow.on('down', pressLeft);
    scene.rightD.on('down', pressRight);
    scene.rightArrow.on('down', pressRight);
    scene.upW.on('down', pressUp);
    scene.upArrow.on('down', pressUp);
    scene.downS.on('down', pressDown);
    scene.downArrow.on('down', pressDown);

    scene.leftA.on('up', releaseLeft);
    scene.leftArrow.on('up', releaseLeft);
    scene.rightD.on('up', releaseRight);
    scene.rightArrow.on('up', releaseRight);
    scene.upW.on('up', releaseUp);
    scene.upArrow.on('up', releaseUp);
    scene.downS.on('up', releaseDown);
    scene.downArrow.on('up', releaseDown);

    scene.spaceBar.on('down', pressSpace);
    scene.enterKey.on('down', pressEnter);
    scene.escKey.on('down', pressEscape);
    scene.keyboardE.on('down', pressE);
    Object.values(scene.keyboardNum).forEach(k => k.on('down', pressNum));
  };

  //gamepad
  scene.input.gamepad && scene.input.gamepad.on('down', gamepadButtonDown);
  scene.input.gamepad && scene.input.gamepad.on('up', gamepadButtonUp);
  // left
  scene.leftA = scene.input.keyboard.addKey('A');
  scene.leftArrow = scene.input.keyboard.addKey('LEFT');
  // right
  scene.rightD = scene.input.keyboard.addKey('D');
  scene.rightArrow = scene.input.keyboard.addKey('RIGHT');
  // up
  scene.upW = scene.input.keyboard.addKey('W');
  scene.upArrow = scene.input.keyboard.addKey('UP');
  // down
  scene.downS = scene.input.keyboard.addKey('S');
  scene.downArrow = scene.input.keyboard.addKey('DOWN');

  //enter/space/esc
  scene.spaceBar = scene.input.keyboard.addKey('SPACE');
  scene.enterKey = scene.input.keyboard.addKey('ENTER');
  scene.escKey = scene.input.keyboard.addKey('ESC');

  // Menu controls
  scene.keyboardE = scene.input.keyboard.addKey('E');

  // Leader promotion
  scene.keyboardNum = scene.input.keyboard.addKeys(
    'ONE, TWO, THREE, FOUR, FIVE, SIX, SEVEN, EIGHT, NINE'
  );

  scene.controllerDecayTime = 400;

  addControllerInputs();

  return [addControllerInputs, removeControllerInputs];
}

const tryToMoveInDirection = (scene, moveInDirection, direction) => {
  clearTimeout(scene.controllerResetTimer);
  scene.controllerResetTimer = setTimeout(() => {
    scene.controllerDirectionBlocked = false;
    scene.controllerDecayTime = 400;
    clearTimeout(scene.controllerBlockingTimer);
  }, 50);
  if (!scene.controllerDirectionBlocked) {
    moveInDirection(direction);
    scene.controllerDirectionBlocked = true;
    scene.controllerBlockingTimer = setTimeout(() => {
      if (scene.controllerDecayTime > 50) {
        scene.controllerDecayTime -= 50;
      }

      scene.controllerDirectionBlocked = false;
    }, scene.controllerDecayTime);
  }
};

export const controllerInputForMenuDirections = (scene, moveInDirection) => {
  const { name, coordinates: direction } = getAnalogueDirection(scene);
  if (name) {
    // console.log('try to move in direction:', direction);
    tryToMoveInDirection(scene, moveInDirection, direction);
  }
};

// const directionsByCoordinates = {
//   up: [
//     { min: -0.2, max: 0.2 },
//     { min: -1, max: -0.2 }
//   ],
//   down: [
//     { min: -0.2, max: 0.2 },
//     { min: 0.2, max: 1 }
//   ],
//   left: [
//     { min: -1, max: -0.2 },
//     { min: -0.2, max: 0.2 }
//   ],
//   right: [
//     { min: 0.2, max: 1 },
//     { min: -0.2, max: 0.2 }
//   ],
//   upLeft: [
//     { min: -1, max: -0.2 },
//     { min: -1, max: -0.2 }
//   ],
//   upRight: [
//     { min: 0.2, max: 1 },
//     { min: -1, max: -0.2 }
//   ],
//   downLeft: [
//     { min: -1, max: -0.2 },
//     { min: 0.2, max: 1 }
//   ],
//   downRight: [
//     { min: 0.2, max: 1 },
//     { min: 0.2, max: 1 }
//   ]
// };

const directionByName = {
  up: [0, -1],
  down: [0, 1],
  left: [-1, 0],
  right: [1, 0],
  upLeft: [-1, -1],
  upRight: [1, -1],
  downLeft: [-1, 1],
  downRight: [1, 1]
};

// top, right, left, bottom = t, r, l, b
// min, max = min, max
// const origin = [0, 0];
const yIntercept = 0;
// game axes are opposite of cartesian axes
const positiveVerticalSlope = -2;
const negativeVerticalSlope = positiveVerticalSlope * -1;
const postiveHorizontalSlope = -0.5;
const negativeHorizontalSlope = postiveHorizontalSlope * -1;
export const lineEndpoints = {
  topMin: { x: -0.4, y: -1, slope: negativeVerticalSlope },
  topMax: { x: 0.4, y: -1, slope: positiveVerticalSlope },
  rightMin: { x: 1, y: -0.4, slope: postiveHorizontalSlope },
  rightMax: { x: 1, y: 0.4, slope: negativeHorizontalSlope },
  leftMin: { x: -1, y: -0.4, slope: negativeHorizontalSlope },
  leftMax: { x: -1, y: 0.4, slope: postiveHorizontalSlope },
  bottomMin: { x: -0.4, y: 1, slope: positiveVerticalSlope },
  bottomMax: { x: 0.4, y: 1, slope: negativeVerticalSlope }
};

const directionZones = {
  up: {
    lines: [lineEndpoints.topMin, lineEndpoints.topMax],
    operators: ['>', '<', '<', '<']
  },
  upLeft: {
    lines: [lineEndpoints.topMin, lineEndpoints.leftMin],
    operators: ['<', '>', '>', '<']
  },
  upRight: {
    lines: [lineEndpoints.topMax, lineEndpoints.rightMin],
    operators: ['>', '>', '<', '<']
  },
  down: {
    lines: [lineEndpoints.bottomMin, lineEndpoints.bottomMax],
    operators: ['>', '>', '<', '>']
  },
  downLeft: {
    lines: [lineEndpoints.bottomMin, lineEndpoints.leftMax],
    operators: ['<', '<', '>', '>']
  },
  downRight: {
    lines: [lineEndpoints.bottomMax, lineEndpoints.rightMax],
    operators: ['>', '<', '<', '>']
  },
  left: {
    lines: [lineEndpoints.leftMin, lineEndpoints.leftMax],
    operators: ['<', '>', '<', '<']
  },
  right: {
    lines: [lineEndpoints.rightMin, lineEndpoints.rightMax],
    operators: ['>', '>', '>', '<']
  }
};

const findZoneWithPoint = point => {
  return Object.keys(directionZones).find(key => {
    const zone = directionZones[key];
    const failure = zone.operators.find((operator, index) => {
      const line = zone.lines[Math.floor(index / 2)];
      const calcX = index % 2 === 0;
      const x = point[0];
      const y = point[1];
      if (calcX) {
        const xAtY = (y - yIntercept) / line.slope;
        const xInZone = operator === '>' ? x >= xAtY : x <= xAtY;
        // console.log('checking:', x, operator, xAtY, xInZone, y, line.slope);
        return !xInZone;
      } else {
        const yAtX = line.slope * x + yIntercept;
        const yInZone = operator === '>' ? y >= yAtX : y <= yAtX;
        // console.log('checking:', y, operator, yAtX, yInZone);
        return !yInZone;
      }
    });
    // console.log('Hitting:', key, failure);
    return !failure;
  });
};

/*
ex:

line from: (0,0) to (0.5,1)
y = mx + b;
b = 0;
y = mx;
0 = 2 * 0;
1 = 2 * 0.5;

slope = (1 - 0) / (0.5 - 0) = 2

Input = (0.1, 0.8);

Is Input < x, & > y of line2, and Input > x & Input > y of line1

*/
export const InnerRadialDeadZoneSize = 0.4;

export const getAnalogueDirection = (scene, whichStick = 'Left') => {
  const pads = scene.input.gamepad && scene.input.gamepad.getAll();
  const controller = pads[0];
  if (!pads || !controller) {
    return { name: '', coordinates: [0, 0] };
  }
  const LX = controller.axes[0].value;
  const LY = controller.axes[1].value;
  const RX = controller.axes[2].value;
  const RY = controller.axes[3].value;
  const stickPoint = whichStick === 'Left' ? [LX, LY] : [RX, RY];

  const magnitude = Math.sqrt(stickPoint[0] ** 2 + stickPoint[1] ** 2);

  if (magnitude < InnerRadialDeadZoneSize) {
    return { name: '', coordinates: [0, 0] };
  }
  // console.log('outside radial deadzone...', magnitude, stickPoint);

  // const stickDirection = Object.keys(directionsByCoordinates).find(key => {
  //   const ranges = directionsByCoordinates[key];
  //   const xRange = ranges[0];
  //   const yRange = ranges[1];
  //   const xInRange = stickPoint[0] >= xRange.min && stickPoint[0] <= xRange.max;
  //   const yInRange = stickPoint[1] >= yRange.min && stickPoint[1] <= yRange.max;
  //   return xInRange && yInRange;
  // });

  const stickDirection2 = findZoneWithPoint(stickPoint);

  // console.log('stick position:', stickDirection, stickDirection2);
  return {
    name: stickDirection2,
    coordinates: directionByName[stickDirection2]
  };
};

export const controllerInputUpdate = scene => {
  const modalScene = window.__clInputModalScene;
  if (modalScene && scene.scene?.key !== modalScene) {
    return;
  }

  const cam = scene.cameras.main;
  const pads = scene.input.gamepad && scene.input.gamepad.getAll();
  if (pads && pads[0] && scene.cursorPointer) {
    const l1 = pads[0].axes[0].value;
    const l2 = pads[0].axes[1].value;
    const analogCursorActive = Math.abs(l1) > 0.3 || Math.abs(l2) > 0.3;
    if (analogCursorActive) {
      scene.controllerCursorAnalogStartedAt =
        scene.controllerCursorAnalogStartedAt || Date.now();
    } else {
      scene.controllerCursorAnalogStartedAt = null;
    }
    const analogHeldMs = scene.controllerCursorAnalogStartedAt
      ? Date.now() - scene.controllerCursorAnalogStartedAt
      : 0;
    const defaultMoveSpeed = analogHeldMs > 1000 ? 4.2 : 3.25;
    const moveSpeed =
      scene.getControllerCursorMoveSpeed?.({
        analogHeldMs,
        analogCursorActive
      }) || defaultMoveSpeed;
    let newX, newY;

    //dpad
    const bluePieces =
      scene.pieces &&
      scene.pieces.getChildren().filter(p => p.color === 'blue');
    const isPawnLeader =
      scene.currentSelectedPiece &&
      (scene.currentSelectedPiece.tile.index === 283 ||
        scene.currentSelectedPiece.tile.index === 271) &&
      bluePieces.length === 1;
    const upPressed = pads[0].buttons[12].pressed;
    const downPressed = pads[0].buttons[13].pressed;
    const leftPressed = pads[0].buttons[14].pressed;
    const rightPressed = pads[0].buttons[15].pressed;

    if (upPressed) {
      scene.game.upPressed = true;
    } else {
      scene.game.upPressed = false;
    }
    if (downPressed) {
      scene.game.downPressed = true;
    } else {
      scene.game.downPressed = false;
    }
    if (leftPressed) {
      scene.game.leftPressed = true;
    } else {
      scene.game.leftPressed = false;
    }
    if (rightPressed) {
      scene.game.rightPressed = true;
    } else {
      scene.game.rightPressed = false;
    }

    if (!isPawnLeader && !scene.isMoving && !scene.isMultiMoving) {
      if (leftPressed) {
        scene.leftPressedFrames += 1;
        if (scene.leftPressedFrames % 12 === 1) {
          newX = scene.cursorPointer.x - 32;
        }
      } else {
        scene.leftPressedFrames = 0;
      }
      if (rightPressed) {
        scene.rightPressedFrames += 1;
        if (scene.rightPressedFrames % 12 === 1) {
          newX = scene.cursorPointer.x + 32;
        }
      } else {
        scene.rightPressedFrames = 0;
      }
      if (downPressed) {
        scene.downPressedFrames += 1;
        if (scene.downPressedFrames % 12 === 1) {
          newY = scene.cursorPointer.y + 32;
        }
      } else {
        scene.downPressedFrames = 0;
      }
      if (upPressed) {
        scene.upPressedFrames += 1;
        if (scene.upPressedFrames % 12 === 1) {
          newY = scene.cursorPointer.y - 32;
        }
      } else {
        scene.upPressedFrames = 0;
      }

      if (newY || newX) {
        scene.game.canvas.style.cursor = 'none';
        scene.cursorPointer.setAlpha(1);
        scene.game.controllerInput = true;
        const modTileSize = scene.map.tileWidth;
        const modTileX = scene.cursorPointer.x % modTileSize;
        const modTileY = scene.cursorPointer.y % modTileSize;
        newX = (newX || scene.cursorPointer.x) - modTileX + modTileSize * 0.5;
        newY = (newY || scene.cursorPointer.y) - modTileY + modTileSize * 0.5;
        scene.cursorPointer.setPosition(newX, newY);
        newY = null;
        newX = null;
      }
    }

    //analog stick
    const inBattle =
      scene.battlingInStory ||
      scene.battlingInWorld ||
      scene.scene.key === 'CastleScene';
    const isDirectInputAllowed = scene.isDirectInputAllowed();
    const isOnlyPawnInBattle = scene.isOnlyPawnInBattle();
    // only move cursor with analog stick in battle, or in editors that opt in
    // console.log(
    //   'move stick:',
    //   isDirectInputAllowed,
    //   scene.isMoving,
    //   scene.inCutscene,
    //   inBattle,
    //   isOnlyPawnInBattle
    // );
    if (
      !isDirectInputAllowed &&
      !scene.isMoving &&
      !scene.inCutscene &&
      (inBattle || scene.allowFreeEditorCursor) &&
      !isOnlyPawnInBattle
    ) {
      // console.log('curosr moved:', scene.currentSelectedPiece);
      if (l1 > 0.3 || l1 < -0.3) {
        newX = scene.cursorPointer.x + moveSpeed * l1;
        const minX = scene.allowFreeEditorCursor
          ? cam.worldView.left - cam.x / cam.zoom
          : cam.worldView.left + 16;
        if (newX < minX) {
          newX = minX;
        } else if (newX > cam.worldView.right - 16) {
          newX = cam.worldView.right - 16;
        }
      }
      if (l2 > 0.3 || l2 < -0.3) {
        newY = scene.cursorPointer.y + moveSpeed * l2;
        if (newY < cam.worldView.top + 16) {
          newY = cam.worldView.top + 16;
        } else if (newY > cam.worldView.bottom - 16) {
          newY = cam.worldView.bottom - 16;
        }
      }
      if (newX || newY) {
        scene.cursorMovedLastUpdate = true;
        if (!scene.cursorPointer.alpha) {
          scene.game.canvas.style.cursor = 'none';
          scene.cursorPointer.setAlpha(1);
          scene.game.controllerInput = true;
          const firstBluePiece = scene.pieces
            .getChildren()
            .find(p => p.color === 'blue');
          if (firstBluePiece?.tile) {
            const startingTile = firstBluePiece.tile;
            scene.cursorPointer.setPosition(
              startingTile.pixelX + scene.map.tileWidth * 1.5,
              startingTile.pixelY + scene.map.tileWidth * 1.5
            );
          } else {
            scene.cursorPointer.setPosition(
              cam.worldView.centerX,
              cam.worldView.centerY
            );
          }
        } else {
          scene.cursorPointer.setPosition(
            newX || scene.cursorPointer.x,
            newY || scene.cursorPointer.y
          );
        }
      }
    }
    if (scene.abilityButton && scene.abilityButton.updateControllerActive) {
      scene.abilityButton.updateControllerActive(scene);
    }
  }
};
